import { useEffect } from "react"

const focusableSelector = [
  "a[href]",
  "button:not([disabled])",
  "input:not([disabled]):not([type=hidden])",
  "textarea:not([disabled])",
  "select:not([disabled])",
  "[tabindex]:not([tabindex='-1'])",
].join(",")

// Shared modal behaviour: focus the given element on open, keep Tab inside
// the modal, close on Escape, lock page scroll, and return focus on close.
const useModal = (containerRef, initialFocusRef, onClose) => {
  useEffect(() => {
    const opener = document.activeElement
    initialFocusRef.current.focus()
    document.body.style.overflow = "hidden"

    const onKeyDown = e => {
      if (e.key === "Escape") {
        onClose()
        return
      }
      if (e.key !== "Tab") return

      const container = containerRef.current
      const items = Array.from(
        container.querySelectorAll(focusableSelector)
      ).filter(el => el.offsetParent !== null)
      if (items.length === 0) return

      const first = items[0]
      const last = items[items.length - 1]
      const active = document.activeElement
      const outside = active === container || !container.contains(active)

      if (e.shiftKey && (active === first || outside)) {
        e.preventDefault()
        last.focus()
      } else if (!e.shiftKey && (active === last || outside)) {
        e.preventDefault()
        first.focus()
      }
    }
    document.addEventListener("keydown", onKeyDown)

    return () => {
      document.removeEventListener("keydown", onKeyDown)
      document.body.style.overflow = ""
      if (opener) opener.focus()
    }
  }, [containerRef, initialFocusRef, onClose])
}

export default useModal
